import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";
import {PredictionWidgetTabClickEvent} from "../models/prediction-widget.tab-click.event";

export class PredictionWidgetTabClickEventHandler extends AnalyticsEventHandler {
  type = PREDICTION_WIDGET.ACTION_TYPES.onTabClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PredictionWidgetTabClickEvent;
  }
}
